import {request, gql} from 'graphql-request'
import {useCallback, useEffect, useState} from "react";
import {GRAPHQL_ENDPOINTS} from "~/config/constants/endpoints";
import {CHAIN_ID} from "~/config/constants/chains";
import BigNumber from "bignumber.js";

export interface LBPairDayData {
  lbPair: {
    id: string
    name: string
    // feesTokenX: string
    // feesTokenY: string
    // tokenXPriceUSD: string
    // tokenYPriceUSD: string
  }
  feesUSD: string
  date: number
}

interface LBPairDayDatas {
  lbpairDayDatas: LBPairDayData[]
}

export const getPoolFeesData = async (graphQLUrl: string, start: number, end: number, first: number = 1000, skip: number = 0): Promise<LBPairDayData[]> => {
  try {
    const query = gql`
        query lbpairDayDatas {
            lbpairDayDatas(
                where: {
                    date_gte: ${start}
                    date_lte: ${end}
                },
                orderBy: date, 
                first: ${first}, 
                skip: ${skip}
            ) {
                lbPair {
                    name
                    id
                    feesTokenX
                    feesTokenY
                    tokenXPriceUSD
                    tokenYPriceUSD
                }
                feesUSD
                date
            }
        }`
    const {lbpairDayDatas} = await request<LBPairDayDatas>(graphQLUrl, query, {
      // startTime: START_DATE,
      //   // skip,
      //   // address,
    }
    // , {
    //   'Access-Control-Allow-Origin': '*',
    //   'Access-Control-Allow-Methods': 'GET,POST,PUT,PATCH,DELETE,HEAD,OPTIONS',
    //   'Access-Control-Allow-Headers': 'Content-Type, Origin, Accept, Authorization, Content-Length, X-Requested-With'
    // }
    )
    return lbpairDayDatas
  } catch (error) {
    console.error('Failed to fetch pool chart data', error)
    return []
  }
}

// export const fetchPoolFeesData = (): any[] => {
//   // const [fees, setFees] = useState()
//   // const [poolFees, setPoolFees] = useState([])
//   // const poolFees = {}
//   // const result = []
//
//   const GRAPHQL_URL = GRAPHQL_ENDPOINTS[CHAIN_ID.FANTOM].metropolisV21InfoUrl
//   const a = getPoolFeesData(GRAPHQL_URL)
//   a.then((result) => {
//     const poolFees = []
//     result.map((lbpairDayData: LBPairDayData) => {
//       const existingEntry = poolFees[lbpairDayData.date]
//       if (existingEntry) {
//         const updatedEntry = [
//           ...existingEntry,
//           {
//             lbPairAddress: lbpairDayData.lbPair.id,
//             lbPairName: lbpairDayData.lbPair.name,
//             feesUSD: lbpairDayData.feesUSD,
//             // feesTokenXUSD: new BigNumber(lbpairDayData.lbPair.feesTokenX).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenXPriceUSD)),
//             // feesTokenYUSD: new BigNumber(lbpairDayData.lbPair.feesTokenY).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenYPriceUSD)),
//           }
//         ]
//         poolFees[lbpairDayData.date] = updatedEntry
//       } else {
//         poolFees[lbpairDayData.date] = [{
//           lbPairAddress: lbpairDayData.lbPair.id,
//           lbPairName: lbpairDayData.lbPair.name,
//           feesUSD: lbpairDayData.feesUSD,
//           // feesTokenXUSD: new BigNumber(lbpairDayData.lbPair.feesTokenX).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenXPriceUSD)),
//           // feesTokenYUSD: new BigNumber(lbpairDayData.lbPair.feesTokenY).multipliedBy(new BigNumber(lbpairDayData.lbPair.tokenYPriceUSD)),
//         }]
//       }
//     })
//     result.concat(poolFees)
//     return result
//   })
//   return []
// }
